import { commits, getters } from '@/modules/core/app/helpers/store';

export const mutations = {
  useMapRenderSlot(state, { widgetId }) {
    state.mapRenderingSlots = new Set([...state.mapRenderingSlots.values(), Number(widgetId)]);
  },
  clearMapRenderSlot(state, { widgetId }) {
    const copy = new Set([...state.mapRenderingSlots.values()]);
    copy.delete(Number(widgetId));
    state.mapRenderingSlots = copy;
  },
  setWidgetAsRendered(state, { widgetId }) {
    const copy = new Set([...state.unrenderedWidgets.values()]);
    copy.delete(Number(widgetId));
    state.unrenderedWidgets = copy;
  },
  setUnrenderedWidgetIds(state, { widgetIds }) {
    state.unrenderedWidgets = new Set([
      ...state.unrenderedWidgets.values(),
      ...widgetIds.map((widgetId) => Number(widgetId)),
    ]);
  },
  setWidgetAsReadyToPaginate(state, { widgetId }) {
    state.readyToPaginateWidgets[widgetId] = true;
  },
  addToResourcesLoadingQueue(state, { widgetId }) {
    state.resourcesLoadingQueue[widgetId] = true;
    state.loadedAndReadyTarget += 1;
  },
  removeFromResourcesLoadingQueue(state, { widgetId }) {
    const resourcesLoadingQueue = { ...state.resourcesLoadingQueue };
    delete resourcesLoadingQueue[widgetId];

    state.resourcesLoadingQueue = resourcesLoadingQueue;
  },
  setPaginationRequiredWidgets(state, { widgetIds, ready = false }) {
    const updatedPaginationRequired = { ...state.readyToPaginateWidgets };

    widgetIds.forEach((widgetId) => {
      if (!Object.hasOwn(state.readyToPaginateWidgets, widgetId)) {
        updatedPaginationRequired[widgetId] = ready;
      }
    });

    state.readyToPaginateWidgets = updatedPaginationRequired;
  },
  updatePaginationPerLayout(state, { layoutId, count }) {
    state.paginationPerLayout[layoutId] = count;
  },
  setPaginationTargetList(state, { targetList }) {
    state.paginationTargetList = targetList;
  },
  removeFromPaginationTargetList(state, { widgetId }) {
    const paginationTargetList = { ...state.paginationTargetList };
    delete paginationTargetList[widgetId];

    state.paginationTargetList = paginationTargetList;
  },
  removeFromPaginationRequired(state, { widgetId, decrement = true }) {
    if (Object.hasOwn(state.readyToPaginateWidgets, widgetId)) {
      const updatedPaginationRequired = { ...state.readyToPaginateWidgets };
      delete updatedPaginationRequired[widgetId];

      state.readyToPaginateWidgets = updatedPaginationRequired;
      if (decrement) {
        commits.dashboardExport.removeFromPaginationTargetList({ widgetId });
      }
    }
  },
  setPaginationReady(state) {
    state.isReadyToPaginate = true;
  },
  addToPaginationQueue(state, { widgetId, ref }) {
    state.paginationQueue[widgetId] = ref;
  },
  pushMeasuredObjects(state, { layoutId, measuredObject }) {
    if (!Object.hasOwn(state.measuredElements, layoutId)) {
      state.measuredElements[layoutId] = [];
    }

    state.measuredElements[layoutId].push(measuredObject);
    state.measuredElementsCounter += 1;
    if (getters.dashboardExport.paginationIsReadyToDisplay()) {
      commits.dashboardExport.setIsReadyToDisplay();
    }
  },
  setIsReadyToDisplay(state) {
    state.isReadyToDisplay = true;
  },
  setExecutiveSummaryPagination(state, { elementId, chunks }) {
    state.executiveSummaryPagination = { ...state.executiveSummaryPagination, [elementId]: chunks };
  },
};
